import { Button, Input, List } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Question from "../../Classes/Question";
import { pickAFileSliceDispatch, questionModalSliceDispatch, questionServiceQuestionBrandModalSliceDispatch, questionViewerSliceDispatch, standardQuestionSliceDispatch } from "../../Constants/ReduxConstants";
import { ReduxHelpers } from "../../Helpers/ReduxHelpers";
import QuestionModal from ".././QuestionModal/QuestionModal";
import StandardQuestionSelectModal from "../StandardQuestions/StandardQuestionSelectModal"

const QuestionViewer = () => {
    const currentQuestions = useSelector((state: any) => state.pickAFile.questions);
    const currentActions = useSelector((state: any) => state.pickAFile.actions);
    const currentRules = useSelector((state: any) => state.pickAFile.rules);
    const currentLayout = useSelector((state: any) => state.pickAFile.layout);
    const currentServiceQuestions = useSelector((state: any) => state.pickAFile.serviceQuestions);
    const currentServiceList = useSelector((state: any) => state.pickAFile.serviceList);
    const currentServiceQuestionBrand = useSelector((state: any) => state.pickAFile.serviceBrandQuestions);
    const currentAddressStart = useSelector((state: any) => state.pickAFile.addressStart);

    const addModal = useSelector((state: any) => state.questionViewer.addModal);
    const editModal = useSelector((state: any) => state.questionViewer.editModal);
    const questionSearchResults = useSelector((state: any) => state.questionViewer.questionSearchResults);

    const dispatch = useDispatch()

    const { CreateContentsFromStates } = ReduxHelpers();

    // Helper function to get service names for a question
    const getAssociatedServices = (questionId) => {
        if (!currentServiceQuestions || !currentServiceList) return [];
        
        const serviceIds = currentServiceQuestions
            .filter(sq => sq.questionId === questionId)
            .map(sq => sq.assistanceServiceId);
            
        return currentServiceList
            .filter(service => serviceIds.includes(service.serviceId))
            .map(service => service.serviceName);
    };

    // Helper function to get question properties as badges
    const getQuestionProperties = (question) => {
        const properties = [];
        
        if (question.required && (question.required === 1 || question.required === true)) {
            properties.push({ text: 'Required', color: '#f50' });
        }
        if (question.hidden && (question.hidden === 1 || question.hidden === true)) {
            properties.push({ text: 'Hidden', color: '#orange' });
        }
        if (question.sensitive) {
            properties.push({ text: 'Sensitive', color: '#red' });
        }
        if (question.readonly) {
            properties.push({ text: 'Read Only', color: '#blue' });
        }
        
        return properties;
    };

    // Helper function to format question type
    const getQuestionType = (question) => {
        const type = question.selectedType || question.type || 'string';
        return type.charAt(0).toUpperCase() + type.slice(1);
    };

    function DeleteAQuestion(idToDelete, deleteFromLayout) {
        let currentQuestionDetail = currentQuestions.filter(question => question.questionId == parseInt(idToDelete) || question.questionId == idToDelete)[0];
        let filteredQuestions = currentQuestions.filter(question => question.questionId != parseInt(idToDelete) || question.questionId != idToDelete);

        dispatch({ type: pickAFileSliceDispatch.setQuestions, payload: filteredQuestions })
        dispatch({ type: questionViewerSliceDispatch.setQuestionSearchResults, payload: filteredQuestions })

        let filteredRules = currentRules;
        let filteredServiceQuestions = currentServiceQuestions;
        let filteredServiceQuestionBrands = currentServiceQuestionBrand;

        //We deleted the question so blow it out of all layouts and actions too
        if (deleteFromLayout) {
            let dataKeyToDeleteFromLayout = currentQuestionDetail.dataKey;

            for (const layout of currentLayout) {
                layout.fields = layout.fields.filter(field => field !== dataKeyToDeleteFromLayout)
            }
            for (const action of currentActions) {
                action.params = action.params.filter(field => field !== dataKeyToDeleteFromLayout)
            }
            for (const rule of filteredRules) {
                if (rule.conditions.all) {
                    rule.conditions.all = rule.conditions.all.filter(condition => condition.fact !== dataKeyToDeleteFromLayout)
                }
                if (rule.conditions.any) {
                    rule.conditions.any = rule.conditions.any.filter(condition => condition.fact !== dataKeyToDeleteFromLayout)
                }
            }
            //Clean up any empty rules
            filteredRules = filteredRules.filter(
                rules => rules.conditions.all && rules.conditions.all.length !== 0 ||
                    rules.conditions.any && rules.conditions.any.length !== 0)

            dispatch({ type: pickAFileSliceDispatch.setRules, payload: filteredRules })

            //Remove any serviceQuestions or serviceQuestionsBrand that contain the question
            filteredServiceQuestions = filteredServiceQuestions.filter(sq => sq.questionId != parseInt(idToDelete))

            dispatch({ type: pickAFileSliceDispatch.setServiceQuestions, payload: filteredServiceQuestions })

            filteredServiceQuestionBrands = filteredServiceQuestionBrands.filter(sqb => sqb.questionId != parseInt(idToDelete))

            dispatch({ type: pickAFileSliceDispatch.setServiceBrandQuestions, payload: filteredServiceQuestionBrands })
        }

        CreateContentsFromStates({ questions: filteredQuestions, serviceQuestions: filteredServiceQuestions });

        return filteredQuestions;
    }

    const HandleDelete = (event) => {
        DeleteAQuestion(event.currentTarget.id, true)
    }

    const onQuestionSearchChange = (event) => {
        let searchValue = event.target.value.toLowerCase();
        let valueToUse = currentQuestions.filter(question => question.label.toLowerCase().includes(searchValue) || question.dataKey.toLowerCase().includes(searchValue))

        dispatch({ type: questionViewerSliceDispatch.setQuestionSearchResults, payload: valueToUse })
    }

    let defaultNewQuestion = new Question();  //Empty default question

    defaultNewQuestion.formId = parseInt(currentAddressStart);

    let maxIndex = currentAddressStart
    if (currentQuestions?.length > 0) {
        maxIndex = Math.max(...currentQuestions.map(o => o.questionId))
        maxIndex++
    }

    const AddModal = (event?: any) => {
        dispatch({ type: questionViewerSliceDispatch.setAddModal, payload: true })
        dispatch({ type: questionViewerSliceDispatch.setEditModal, payload: false })
        dispatch({ type: questionModalSliceDispatch.setOpen, payload: true });
    }

    const EditModal = (event?: any) => {
        dispatch({ type: questionViewerSliceDispatch.setEditModal, payload: true })
        dispatch({ type: questionViewerSliceDispatch.setAddModal, payload: false })
        dispatch({ type: questionModalSliceDispatch.setOpen, payload: true });
    }

    const questions =
        <div>
            <Input style={{ width: '149px' }} id="questionSearchResults" placeholder='Search...' onChange={onQuestionSearchChange} />
            <br />
            <br />
            <Button
                onClick={() => {
                    AddModal();
                    dispatch({ type: questionModalSliceDispatch.setQuestionToAdd, payload: defaultNewQuestion });
                    dispatch({ type: questionModalSliceDispatch.setPendingServices, payload: [] });
                    dispatch({ type: questionViewerSliceDispatch.setCurrentQuestion, payload: defaultNewQuestion });
                    dispatch({ type: questionViewerSliceDispatch.setIndexOverride, payload: maxIndex });
                    dispatch({ type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions, payload: [] });
                }}>
                Add new Question
            </Button>
            <Button
                onClick={() => {
                    dispatch({ type: standardQuestionSliceDispatch.setSelectOpen, payload: true });
                    dispatch({ type: questionModalSliceDispatch.setQuestionToAdd, payload: new Question()});
                    dispatch({ type: questionViewerSliceDispatch.setCurrentQuestion, payload: new Question()});
                }}>
                Add Standard Question
            </Button>
            {addModal && <QuestionModal />}
            {editModal && <QuestionModal />}
            <StandardQuestionSelectModal />
            <List
                dataSource={questionSearchResults?.sort((a: any, b: any) => a.questionId > b.questionId ? 1 : -1)}
                renderItem={(currentQuestion: any, index: number) => {
                    const associatedServices = getAssociatedServices(currentQuestion.questionId);
                    const properties = getQuestionProperties(currentQuestion);
                    const questionType = getQuestionType(currentQuestion);
                    
                    return (
                        <div key={"question_" + currentQuestion.dataKey}>
                            <List.Item key={currentQuestion.dataKey}>
                                <div style={{ width: '100%' }}>
                                    {/* Main question info row */}
                                    <div style={{ 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        gap: '10px',
                                        marginBottom: '8px'
                                    }}>
                                        <Button 
                                            onClick={() => {
                                                // Set all modal state BEFORE opening the modal to avoid race conditions
                                                dispatch({
                                                    type: questionModalSliceDispatch.setPendingServices,
                                                    payload: currentServiceQuestions.filter(s => s.questionId === currentQuestion.questionId).map(s => s.assistanceServiceId) ?? []
                                                });
                                                dispatch({ type: questionModalSliceDispatch.setQuestionToAdd, payload: currentQuestion });
                                                dispatch({ type: questionViewerSliceDispatch.setCurrentQuestion, payload: currentQuestion });
                                                dispatch({ type: questionViewerSliceDispatch.setIndexOverride, payload: currentAddressStart + index });
                                                dispatch({
                                                    type: questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions,
                                                    payload: currentServiceQuestionBrand.filter(s => s.questionId === currentQuestion.questionId)
                                                });
                                                // Open modal LAST after all state is set
                                                EditModal();
                                            }}
                                            title="Edit Question"
                                            style={{
                                                padding: '4px 8px',
                                                fontSize: '14px',
                                                minWidth: 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            ✏️
                                        </Button>
                                        <Button 
                                            key={"question_" + currentQuestion.questionId} 
                                            id={currentQuestion.questionId} 
                                            onClick={HandleDelete}
                                            title="Delete Question"
                                            style={{
                                                padding: '4px 8px',
                                                fontSize: '14px',
                                                minWidth: 'auto',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            🗑️
                                        </Button>
                                        <strong style={{ fontSize: '14px', color: 'var(--text-primary)' }}>
                                            ({currentQuestion.questionId}) {currentQuestion.dataKey}
                                        </strong>
                                        {currentQuestion.label && (
                                            <span style={{ 
                                                fontSize: '12px', 
                                                color: 'var(--text-secondary)',
                                                fontStyle: 'italic'
                                            }}>
                                                ({currentQuestion.label})
                                            </span>
                                        )}
                                    </div>
                                    
                                    {/* Details row */}
                                    <div style={{ 
                                        display: 'flex', 
                                        flexWrap: 'wrap', 
                                        gap: '8px',
                                        alignItems: 'center',
                                        marginLeft: '140px' // Align with question data after buttons
                                    }}>
                                        {/* Question Type */}
                                        <span style={{
                                            background: 'var(--bg-secondary)',
                                            color: 'var(--text-primary)',
                                            padding: '2px 6px',
                                            borderRadius: '4px',
                                            fontSize: '11px',
                                            fontWeight: 'bold'
                                        }}>
                                            {questionType}
                                        </span>
                                        
                                        {/* Properties */}
                                        {properties.map((prop, idx) => (
                                            <span key={idx} style={{
                                                background: prop.color,
                                                color: 'white',
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                fontSize: '11px',
                                                fontWeight: 'bold'
                                            }}>
                                                {prop.text}
                                            </span>
                                        ))}
                                        
                                        {/* Associated Services */}
                                        {associatedServices.length > 0 && (
                                            <div style={{ 
                                                display: 'flex', 
                                                alignItems: 'center', 
                                                gap: '4px' 
                                            }}>
                                                <span style={{ 
                                                    fontSize: '11px', 
                                                    color: 'var(--text-secondary)',
                                                    fontWeight: 'bold'
                                                }}>
                                                    Services:
                                                </span>
                                                {associatedServices.map((serviceName, idx) => (
                                                    <span key={idx} style={{
                                                        background: '#1890ff',
                                                        color: 'white',
                                                        padding: '2px 6px',
                                                        borderRadius: '4px',
                                                        fontSize: '11px'
                                                    }}>
                                                        {serviceName}
                                                    </span>
                                                ))}
                                            </div>
                                        )}
                                        
                                        {associatedServices.length === 0 && (
                                            <span style={{
                                                background: '#d9d9d9',
                                                color: '#666',
                                                padding: '2px 6px',
                                                borderRadius: '4px',
                                                fontSize: '11px',
                                                fontStyle: 'italic'
                                            }}>
                                                No services
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </List.Item>
                        </div>
                    );
                }}
            />
        </div >
    return <div>{questions}</div>
}

export default QuestionViewer;